<template>
  <div>
    <NxInput
      name="email"
      type="email"
      label="Email:"
      placeholder="Ex: exemplo@exemplo.com"
      :value="localValue"
      @update:value="handleValueUpdate"
      @blur="validateEmail"
      :isDisabled="isDisabled"
    ></NxInput>
  </div>
</template>

<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputEmail',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    },
    validateEmail () {
      const emailRegex = /^[a-z0-9.]+@[a-z0-9]+\.[a-z.]{2,}$/i
      if (!emailRegex.test(this.localValue)) toast.warning('E-mail inválido')
    }
  }
}
</script>

<style scoped>
.is-invalid {
  border-color: red;
}
.error-message {
  color: red;
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputEmail.vue